export interface PurchaseOrderGenericItem {
    id: number;
    position?: number;
    price?: number;
    tax: number;
    discount?: number;
    title: string;
    description?: string;
    quantity: number;
    type: PurchaseOrderGenericItemType;
}

export enum PurchaseOrderGenericItemType {
    Surcharge = 'SURCHARGE',
    ShippingCosts = 'SHIPPING_COSTS',
}
